import { translateFunc } from "client/utils/translateFunc";
import { DownloadIcon } from "components/common/Icons/DownloadIcon";
import { Loader } from "components/common/Icons/Loader/Loader";
import { useAction } from "../../Action/useAction";

export const Download = () => {
    const { handleClick, isProcessing } = useAction();

    return (
        <div
            className={`flex items-center justify-center gap-4 flex-grow text-white font-semibold text-xl`}
            onClick={handleClick}
        >
            <div className="">
                {isProcessing ? <Loader className="stroke-white" width={20} height={20} /> : <DownloadIcon />}
            </div>
            <div className="capitalize">{translateFunc("common:download")}</div>
        </div>
    );
};
